/**
 * Product List Carousel JavaScript
 * Makes product_list-wrapper and matching_sets_product_list-wrapper elements work like product-carousel-container
 * Replaces Slick.js with vanilla JavaScript carousel functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize product_list-wrapper and matching_sets_product_list-wrapper carousels
  function initProductListCarousels() {
    const carousels = document.querySelectorAll('.product_list-wrapper, .matching_sets_product_list-wrapper');
    
    carousels.forEach(carousel => {
      // Skip if already initialized
      if (carousel.dataset.carouselInitialized === 'true') return;
      carousel.dataset.carouselInitialized = 'true';
      
      const track = carousel.querySelector('.product-carousel-track');
      const prevBtn = carousel.querySelector('.carousel-btn-prev');
      const nextBtn = carousel.querySelector('.carousel-btn-next');
      const items = carousel.querySelectorAll('.product_list-item, .matching_sets_product_box');
      
      if (!track || !items.length) return;
      
      let currentIndex = 0;
      
      function getItemsPerView() {
        if (window.innerWidth >= 1200) return 5; // Large Desktop: 6 columns
        if (window.innerWidth >= 768) return 3; // Tablet: 3 columns
        if (window.innerWidth >= 480) return 2; // Small tablet: 2 columns
        return 1; // Mobile: 1 column
      }
      
      function updateCarouselPosition() {
        const itemsPerView = getItemsPerView();
        const maxIndex = Math.max(0, items.length - itemsPerView);
        const itemWidth = 100 / itemsPerView; // Percentage width per item
        const translateX = -(currentIndex * itemWidth);
        
        track.style.transform = `translateX(${translateX}%)`;
        track.style.transition = 'transform 0.3s ease';
        
        // Hide arrows if there are fewer than 6 cards total OR if there aren't enough products to scroll
        const needsNavigation = items.length >= 6 && items.length > itemsPerView;
        
        // Update button states and visibility
        if (prevBtn) {
          prevBtn.disabled = currentIndex === 0;
          prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
          prevBtn.style.display = needsNavigation ? 'flex' : 'none';
        }
        
        if (nextBtn) {
          nextBtn.disabled = currentIndex >= maxIndex;
          nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
          nextBtn.style.display = needsNavigation ? 'flex' : 'none';
        }
      }
      
      // Navigation button handlers
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const itemsPerView = getItemsPerView();
          currentIndex = Math.max(0, currentIndex - itemsPerView);
          updateCarouselPosition();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const itemsPerView = getItemsPerView();
          const maxIndex = Math.max(0, items.length - itemsPerView);
          currentIndex = Math.min(maxIndex, currentIndex + itemsPerView);
          updateCarouselPosition();
        });
      }
      
      // Touch/swipe support
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      });
      
      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
      });
      
      track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;
        
        // Only trigger if horizontal swipe is more significant than vertical
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          const itemsPerView = getItemsPerView();
          const maxIndex = Math.max(0, items.length - itemsPerView);
          
          if (diffX > 0) {
            // Swipe left - next
            currentIndex = Math.min(maxIndex, currentIndex + itemsPerView);
          } else {
            // Swipe right - previous
            currentIndex = Math.max(0, currentIndex - itemsPerView);
          }
          updateCarouselPosition();
        }
      });
      
      // Handle window resize
      window.addEventListener('resize', () => {
        const itemsPerView = getItemsPerView();
        const maxIndex = Math.max(0, items.length - itemsPerView);
        
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        
        updateCarouselPosition();
      });
      
      // Set initial position
      updateCarouselPosition();
    });
  }
  
  // Initialize carousels when tabs are switched
  function reinitializeCarouselsOnTabSwitch() {
    const tabLinks = document.querySelectorAll('.nav_tab-btn, .w-tab-link');
    
    tabLinks.forEach(link => {
      link.addEventListener('click', () => {
        // Small delay to allow tab content to be visible
        setTimeout(() => {
          initProductListCarousels();
        }, 100);
      });
    });
  }
  
  // Initialize everything
  initProductListCarousels();
  reinitializeCarouselsOnTabSwitch();
  
  // Also reinitialize when dropdowns are opened (for header navigation)
  const dropdownToggles = document.querySelectorAll('.header_dropdown-toggle');
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      setTimeout(() => {
        initProductListCarousels();
      }, 300); // Wait for dropdown animation
    });
  });
  
  console.log('Product List Carousel initialized');
});
